<template>
  <div class="flex flex-col flex-1 min-w-0 h-full">
    <div class="box-header">
      <div class="box-title">
        {{ $tc('my_open_request', 2) }}
        <div class="total-count">
          {{ total }}
        </div>
      </div>
      <div class="box-action">
        <FlotoLink :to="$currentModule.getRoute('my-requests')">
          <MIcon name="view-more" size="2x" />
        </FlotoLink>
      </div>
    </div>
    <MDivider class="mt-1 mb-2" />
    <div
      v-if="!myRequests.length"
      class="flex flex-1 items-center jutify-center"
    >
      <FlotoNoData size="small" />
    </div>
    <RequestItem
      v-for="request in myRequests"
      v-else
      :key="request.id"
      :item="request"
      :module-name="moduleName"
    />
  </div>
</template>

<script>
import CloneDeep from 'lodash/cloneDeep'
import {
  transformSearchCriteriasForServer,
  transformSearchCriteriaForServer,
} from '@data/search'
import { StatusComputed } from '@state/modules/status'
import { getMyRequestsApi } from '../../support-portal-api'
import RequestItem from './request-item.vue'
export default {
  name: 'MyOpenRequests',
  components: { RequestItem },
  data() {
    this.moduleName = this.$constants.REQUEST
    return {
      searchCriteria: transformSearchCriteriasForServer(this.moduleName, []),
      myRequests: [],
      total: 0,
    }
  },
  computed: {
    ...StatusComputed,
    openStatusId() {
      if (this[`${this.moduleName}FindStatus`]) {
        return this[`${this.moduleName}FindStatus`]('open').id
      }
      return undefined
    },
  },
  created() {
    this.getMyOpenRequests()
  },
  methods: {
    getMyOpenRequests() {
      if (this.openStatusId) {
        const criterias = CloneDeep(this.searchCriteria)
        const q = transformSearchCriteriaForServer(this.moduleName, {
          operator: { value: 'in' },
          paramName: 'statusId',
          value: this.openStatusId,
          valueType: 'long',
        })
        criterias.quals.push(q)
        getMyRequestsApi(criterias, 5, 0).then(({ items, total }) => {
          this.myRequests = items
          this.total = total
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.box-header {
  @apply flex justify-between items-center;

  & .box-title {
    @apply flex pb-1;

    font-size: 0.898rem;
    font-weight: 500;
    color: var(--primary-alt);
  }

  & .total-count {
    @apply flex px-2 items-center rounded;

    margin: 0 0.418rem;
    font-size: 0.7rem;
    color: var(--primary);
    background-color: rgba(0, 157, 220, 0.2);
  }

  & .box-action {
    @apply cursor-pointer;

    color: var(--primary);
  }
}
</style>
